
    import './styles.scoped.css';
    export default {
  "body-cell": "awsui_body-cell_c6tup_mft2u_93",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_mft2u_106",
  "is-visual-refresh": "awsui_is-visual-refresh_c6tup_mft2u_118",
  "has-striped-rows": "awsui_has-striped-rows_c6tup_mft2u_130",
  "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_mft2u_133",
  "body-cell-editable": "awsui_body-cell-editable_c6tup_mft2u_133",
  "has-striped-rows-sticky-cell-pad-left": "awsui_has-striped-rows-sticky-cell-pad-left_c6tup_mft2u_139",
  "has-selection": "awsui_has-selection_c6tup_mft2u_142",
  "body-cell-first-row": "awsui_body-cell-first-row_c6tup_mft2u_148",
  "body-cell-last-row": "awsui_body-cell-last-row_c6tup_mft2u_151",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_mft2u_151",
  "has-footer": "awsui_has-footer_c6tup_mft2u_151",
  "body-cell-shaded": "awsui_body-cell-shaded_c6tup_mft2u_161",
  "sticky-cell": "awsui_sticky-cell_c6tup_mft2u_187",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_c6tup_mft2u_195",
  "sticky-cell-last-right": "awsui_sticky-cell-last-right_c6tup_mft2u_212",
  "sticky-cell-last-left": "awsui_sticky-cell-last-left_c6tup_mft2u_216",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_mft2u_239",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_mft2u_243",
  "body-cell-editor": "awsui_body-cell-editor_c6tup_mft2u_267",
  "body-cell-success": "awsui_body-cell-success_c6tup_mft2u_274",
  "body-cell-success-form": "awsui_body-cell-success-form_c6tup_mft2u_301",
  "body-cell-editor-form": "awsui_body-cell-editor-form_c6tup_mft2u_301",
  "body-cell-success-row": "awsui_body-cell-success-row_c6tup_mft2u_311",
  "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_mft2u_311",
  "body-cell-success-controls": "awsui_body-cell-success-controls_c6tup_mft2u_321",
  "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_mft2u_321",
  "body-cell-disabled-edit": "awsui_body-cell-disabled-edit_c6tup_mft2u_324",
  "body-cell-edit-disabled-popover": "awsui_body-cell-edit-disabled-popover_c6tup_mft2u_364",
  "body-cell-has-success": "awsui_body-cell-has-success_c6tup_mft2u_368"
};
  